import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  emptyTemplateWrapper: {
    height: 132,
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderStyle: 'dashed',
    borderColor: colors.newUI.therapist.blue60,
    borderWidth: 2,
    borderRadius: 8,
  },
  emptyTemplateButtonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyTemplateButton: {
    backgroundColor: colors.newUI.therapist.grey20,
    padding: 10,
    borderRadius: 8,
  },
  itemRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    width: '100%',
  },
  itemRowBorder: {
    borderTopWidth: 1,
    borderTopColor: colors.newUI.therapist.grey20,
  },
  itemImage: {
    width: 44,
    height: 44,
    borderRadius: 8,
    marginRight: 20,
  },
});
